/*=====================================
  What a membership is a membership OF.

  A membership carries a store or it does not: with one it scopes the account
  to that store, without one it scopes them to Seldit itself. The switcher
  lists only the first kind - the platform's own context is not a store and
  has its own way out, in the profile menu.

  Mirrors MembershipKind in the API.
======================================*/
export enum MembershipKind {
    TENANT = 'tenant',
    SELDIT = 'seldit',
}
